module.exports = __webpack_public_path__ + "static/media/nu.41159457.svg";